module.exports = __webpack_public_path__ + "static/snow_plows-7c35f76766eff9b502e1969575b4cfff.jpg";